<div class="w-full h-full pt-6 px-6 flex flex-col justify-start items-center overflow-auto">
  <div class="w-full max-w-xl flex flex-col justify-start items-center gap-6 pb-10">
    <app-back-header (backClicked)="close()"/>
    <app-icon-badge-header titleKey="components.cookie_preferences.title"/>

    <div class="w-full bg-card-background border border-solid border-default-dark rounded p-4 flex flex-col gap-4">
      <p class="text-sm text-default-gray m-0">{{ 'components.cookie_preferences.description' | translate }}</p>

      <!--
        One flat list of choices. Each row's own title says what it governs — "Cookies necesarias",
        "Cookies de analítica" — so grouping headings would only repeat the word above the rows that
        already carry it.
      -->

      <!-- Necessary: no toggle, because there is no choice to offer -->
      <div class="flex items-start justify-between gap-4 border border-solid border-border-gray rounded p-3">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-semibold text-title">{{ 'components.cookie_preferences.cookies.necessary.title' | translate }}</span>
          <span class="text-xs text-light-gray">{{ 'components.cookie_preferences.cookies.necessary.description' | translate }}</span>
        </div>
        <mat-slide-toggle [checked]="true" [disabled]="true" color="accent"
          [attr.aria-label]="'components.cookie_preferences.cookies.necessary.title' | translate"></mat-slide-toggle>
      </div>

      <div class="flex items-start justify-between gap-4 border border-solid border-border-gray rounded p-3">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-semibold text-title">{{ 'components.cookie_preferences.cookies.analytics.title' | translate }}</span>
          <span class="text-xs text-light-gray">{{ 'components.cookie_preferences.cookies.analytics.description' | translate }}</span>
        </div>
        <mat-slide-toggle [checked]="analytics()" (change)="analytics.set($event.checked)" color="accent"
          [attr.aria-label]="'components.cookie_preferences.cookies.analytics.title' | translate"></mat-slide-toggle>
      </div>

      <div class="flex items-start justify-between gap-4 border border-solid border-border-gray rounded p-3">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-semibold text-title">{{ 'components.cookie_preferences.cookies.marketing.title' | translate }}</span>
          <span class="text-xs text-light-gray">{{ 'components.cookie_preferences.cookies.marketing.description' | translate }}</span>
        </div>
        <mat-slide-toggle [checked]="marketing()" (change)="marketing.set($event.checked)" color="accent"
          [attr.aria-label]="'components.cookie_preferences.cookies.marketing.title' | translate"></mat-slide-toggle>
      </div>

      <!-- Communications: account-level rather than browser-level, so signed-in users only. -->
      <ng-container *ngIf="showCommunications()">
        <div class="flex items-start justify-between gap-4 border border-solid border-border-gray rounded p-3">
          <div class="flex flex-col gap-1">
            <span class="text-sm font-semibold text-title">{{ 'components.cookie_preferences.communications.marketing.title' | translate }}</span>
            <span class="text-xs text-light-gray">{{ 'components.cookie_preferences.communications.marketing.description' | translate }}</span>
            <!-- The row stays visible with its value unknown rather than disappearing: this dialog is
                 the way to withdraw, so a missing row reads as "there was nothing to withdraw". -->
            <ng-container *ngIf="communicationsUnavailable()">
              <span class="text-xs text-alert">{{ 'components.cookie_preferences.communications.load_error' | translate }}</span>
              <button type="button"
                      class="link-button text-link-highlight underline text-xs hover:cursor-pointer w-fit"
                      [disabled]="isRetrying()"
                      (click)="retryCommunications()">
                {{ 'common.buttons.retry' | translate }}
              </button>
            </ng-container>
          </div>
          <mat-spinner *ngIf="isRetrying()" diameter="20"></mat-spinner>
          <mat-slide-toggle *ngIf="!isRetrying()" color="accent"
            [checked]="marketingComms()" [disabled]="communicationsUnavailable()"
            (change)="setMarketingComms($event.checked)"
            [attr.aria-label]="'components.cookie_preferences.communications.marketing.title' | translate"></mat-slide-toggle>
        </div>
      </ng-container>

      <!-- The one route to the policy from the consent ask. The banner is a strip with no room for
           it, so it lives here, one click away under "Configurar" — a request to consent to
           analytics and marketing has to leave the document describing them reachable. -->
      <p class="text-xs text-light-gray m-0">
        {{ 'components.cookie_preferences.footnote' | translate }}
        {{ 'components.cookie_preferences.policy_link_prefix' | translate }}
        <button type="button"
                class="link-button text-link-highlight underline text-xs hover:cursor-pointer"
                (click)="openPrivacyPolicy()">{{ 'legal_documents.dpp_title' | translate }}</button>.
      </p>
    </div>

    <!-- Actions: reject and accept are the same size, weight and colour as save -->
    <div class="flex flex-col gap-2 w-full">
      <div class="flex flex-col gap-2 sm:flex-row">
        <button mat-raised-button color="accent" class="flex-1" [disabled]="isSaving()" (click)="rejectAllCookies()">
          {{ 'components.cookie_banner.reject_all' | translate }}
        </button>
        <button mat-raised-button color="accent" class="flex-1" [disabled]="isSaving()" (click)="acceptAllCookies()">
          {{ 'components.cookie_banner.accept_all' | translate }}
        </button>
      </div>
      <button mat-raised-button color="accent" class="w-full" [disabled]="isSaving()" (click)="save()">
        {{ 'components.cookie_preferences.save' | translate }}
      </button>
    </div>
  </div>
</div>
